module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAABnRSTlMAAAAAAABupgeRAAAA10lEQVR4AWOgC7iy3opIhNBwVFGNIMKmQUHtqLr6UXm1I7G6QARkgLgKuDUc09U4laF/zF3rTLrO2XQdIAPIBQri1mCleW6R2akU/S151htybIGMc4vNjllr4tZgqXF+nsmhaTbN1VH1VTFHp1udn258TE8dtx+01E/G6BztMGvr8prc53y81/RwmP4ReRx+gFrioXUyTudYn+HRHqNj8bob0qwPa2jg1iCndsxB86ixxpkmozPNRkc11I9pq+MMViiSBWpTPaqnDkRA/cCQRdZAekwPSgAAvNjOUo9nMaAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/ME.png
// module id = 1203
// module chunks = 0